import OvertimePrintSheet from '@/components/print/OvertimePrintSheet';
import LeavePrintSheet from '@/components/print/LeavePrintSheet';
import LeaveTransferPrintSheet from '@/components/print/LeaveTransferPrintSheet';
import WorkDeclarationPrintSheet from '@/components/print/WorkDeclarationPrintSheet';
import TravelExpensePrintSheet from '@/components/print/TravelExpensePrintSheet';

// Screen-preview class per form type (matches PrintPage / ViewSubmission).
export const PAGE_CLASS = {
  overtime: 'print-overtime preview-overtime',
  leave: 'print-leave preview-leave',
  leave_transfer: 'print-leave-transfer preview-leave-transfer',
  work_declaration: 'print-work-declaration preview-work-declaration',
  travel_expense: 'print-travel preview-travel',
};

export function renderFormSheet(submission) {
  switch (submission.form_type) {
    case 'overtime': return <OvertimePrintSheet submission={submission} />;
    case 'leave': return <LeavePrintSheet submission={submission} />;
    case 'leave_transfer': return <LeaveTransferPrintSheet submission={submission} />;
    case 'work_declaration': return <WorkDeclarationPrintSheet submission={submission} />;
    case 'travel_expense': return <TravelExpensePrintSheet submission={submission} />;
    default: return null;
  }
}
